export enum UserRoleEnum {
  Admin = 1001,
  Contributor = 2001,
  Reader = 3002,
  External = 4001,
}
